export const SLIDES_TO_SHOW_DESKTOP = 3;

export const SLIDES_TO_SHOW_MOBILE = 2;
